/* tslint:disable */
/* eslint-disable */
/**
 * Credit API
 * API for banking integrations
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { SlackCapitalRequest } from '../model';
// @ts-ignore
import { SlackCapitalResponse } from '../model';
/**
 * SlackRequestApi - axios parameter creator
 * @export
 */
export const SlackRequestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates or updates entities to mark them as capital entities. This endpoint is designed for Slack integration and requires Slack API key authentication.  For each corporate number: - If entity exists: updates existing entity - If entity doesn\'t exist: creates new entity  **Authentication**: Requires Slack API key in Authorization header. 
         * @summary Mark entities as capital via Slack
         * @param {SlackCapitalRequest} slackCapitalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1SlackEntitiesCapitalPost: async (slackCapitalRequest: SlackCapitalRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slackCapitalRequest' is not null or undefined
            assertParamExists('v1SlackEntitiesCapitalPost', 'slackCapitalRequest', slackCapitalRequest)
            const localVarPath = `/v1/slack/entities/capital`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(slackCapitalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SlackRequestApi - functional programming interface
 * @export
 */
export const SlackRequestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SlackRequestApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates or updates entities to mark them as capital entities. This endpoint is designed for Slack integration and requires Slack API key authentication.  For each corporate number: - If entity exists: updates existing entity - If entity doesn\'t exist: creates new entity  **Authentication**: Requires Slack API key in Authorization header. 
         * @summary Mark entities as capital via Slack
         * @param {SlackCapitalRequest} slackCapitalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1SlackEntitiesCapitalPost(slackCapitalRequest: SlackCapitalRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SlackCapitalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1SlackEntitiesCapitalPost(slackCapitalRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SlackRequestApi - factory interface
 * @export
 */
export const SlackRequestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SlackRequestApiFp(configuration)
    return {
        /**
         * Creates or updates entities to mark them as capital entities. This endpoint is designed for Slack integration and requires Slack API key authentication.  For each corporate number: - If entity exists: updates existing entity - If entity doesn\'t exist: creates new entity  **Authentication**: Requires Slack API key in Authorization header. 
         * @summary Mark entities as capital via Slack
         * @param {SlackRequestApiV1SlackEntitiesCapitalPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1SlackEntitiesCapitalPost(requestParameters: SlackRequestApiV1SlackEntitiesCapitalPostRequest, options?: AxiosRequestConfig): AxiosPromise<SlackCapitalResponse> {
            return localVarFp.v1SlackEntitiesCapitalPost(requestParameters.slackCapitalRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v1SlackEntitiesCapitalPost operation in SlackRequestApi.
 * @export
 * @interface SlackRequestApiV1SlackEntitiesCapitalPostRequest
 */
export interface SlackRequestApiV1SlackEntitiesCapitalPostRequest {
    /**
     * 
     * @type {SlackCapitalRequest}
     * @memberof SlackRequestApiV1SlackEntitiesCapitalPost
     */
    readonly slackCapitalRequest: SlackCapitalRequest
}

/**
 * SlackRequestApi - object-oriented interface
 * @export
 * @class SlackRequestApi
 * @extends {BaseAPI}
 */
export class SlackRequestApi extends BaseAPI {
    /**
     * Creates or updates entities to mark them as capital entities. This endpoint is designed for Slack integration and requires Slack API key authentication.  For each corporate number: - If entity exists: updates existing entity - If entity doesn\'t exist: creates new entity  **Authentication**: Requires Slack API key in Authorization header. 
     * @summary Mark entities as capital via Slack
     * @param {SlackRequestApiV1SlackEntitiesCapitalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlackRequestApi
     */
    public v1SlackEntitiesCapitalPost(requestParameters: SlackRequestApiV1SlackEntitiesCapitalPostRequest, options?: AxiosRequestConfig) {
        return SlackRequestApiFp(this.configuration).v1SlackEntitiesCapitalPost(requestParameters.slackCapitalRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
